import { useCallback, useEffect, useState } from "react";
import { fetchSystemHealthData, SystemHealthData } from "../services/systemHealthService";

export function useSystemHealth() {
  const [data, setData] = useState<SystemHealthData | null>(null);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const refresh = useCallback(async () => {
    setIsLoading(true);
    setError("");

    try {
      setData(await fetchSystemHealthData());
    } catch {
      setData(null);
      setError("Unable to load system health signals. Check Firebase permissions and indexes.");
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return {
    data,
    error,
    isLoading,
    refresh
  };
}
